export { default } from './CtaImageMultipleText';
